// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Assets/Images/red-trash.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.newcharlist-user-remove {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.newcharlist-options {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}

.newchatlist-button {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-start;
  margin-top: 20px;
}
.newchatlist-button > button:not(:first-child) {
  margin-right: 5px;
}

.newchatlist-content {
  padding: 30px 24px 30px 24px;
  gap: 24px;
  background: #fefefe;
  border: 1px solid #e8ecef;
  border-radius: 12px;
}

.newchatlist-content h4 {
  font-weight: 600;
  letter-spacing: 0.5px;
  text-align: left;
  width: fit-content;
  letter-spacing: -0.5px;
}

.newchatlist-content .form-group {
  margin-bottom: 0px;
}

.newchatlist-content .form-group label {
  color: #141718;
  margin-bottom: 10px;
}

.newchatlist-container {
  flex-direction: row;
  width: 600px;
}

.newchatlist-column {
  display: flex;
  flex-direction: column;
  flex: 1 1;
}
.newchatlist-column small {
  margin-top: 20px;
  color: #B6B8B9;
}

.newchatlist-column h5 {
  margin-bottom: 10px;
  margin-top: 20px;
  font-weight: 600;
  letter-spacing: -0.5px;
  font-size: 15px;
}

.newchatlist-row {
  display: flex;
  flex: 1 1;
  align-items: center;
}

.newchatlist-select-color {
  margin-left: 20px;
  width: 265px;
}

.newchatlist-name {
  width: 265px;
}

.newchatlist-name-input {
  height: 48px;
  border-radius: 12px;
  border-color: #E7ECEE;
}

.input-container {
  display: flex;
  align-items: center;
  border: 1px solid #E7ECEE;
  border-radius: 12px;
  padding: 4px 6px 4px 16px;
}

.icon-container {
  display: flex;
  align-items: center;
  padding: 4px;
}

.search-icon {
  color: #B6B8B9;
}

.input-field {
  flex: 1 1;
  border: none;
  padding: 8px;
  font-size: 14px;
}

.select-container-mail {
  width: 330px;
  border: "none";
  box-shadow: "none";
}

.newcharlist-select-color-container {
  border: 1px solid #E7ECEE;
}

.newcharlist-select-color {
  box-shadow: none;
  width: 265px;
}

.newcharlist-panel {
  border: 1px solid #E7ECEE;
  border-radius: 12px;
  padding: 16px;
  background-color: #fff;
}

.newchatlist-card {
  margin-left: 30px;
  justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/Components/NewChatlist/newchatlist.scss"],"names":[],"mappings":"AAAA;EACE,6DAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,2BAAA;EACA,2BAAA;EACA,gBAAA;AACF;AACE;EACE,iBAAA;AACJ;;AAGA;EACE,4BAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,cAAA;EACA,mBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,YAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAAF;AAEE;EACE,gBAAA;EACA,cAAA;AAAJ;;AAIA;EACE,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;AADF;;AAIA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AADF;;AAIA;EACE,iBAAA;EACA,YAAA;AADF;;AAIA;EACE,YAAA;AADF;;AAIA;EACE,YAAA;EACA,mBAAA;EACA,qBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,SAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AADF;;AAIA;EACE,YAAA;EACA,cAAA;EACA,kBAAA;AADF;;AAIA;EACE,yBAAA;AADF;;AAIA;EACE,gBAAA;EACA,YAAA;AADF;;AAIA;EACE,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;AADF;;AAKA;EACE,iBAAA;EACA,8BAAA;AAFF","sourcesContent":[".newcharlist-user-remove {\n  background: url(\"../../Assets/Images/red-trash.svg\") no-repeat;\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n}\n\n.newcharlist-options {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n}\n\n.newchatlist-button {\n  display: flex;\n  flex-direction: row-reverse;\n  justify-content: flex-start;\n  margin-top: 20px;\n\n  >button:not(:first-child) {\n    margin-right: 5px;\n  }\n}\n\n.newchatlist-content {\n  padding: 30px 24px 30px 24px;\n  gap: 24px;\n  background: #fefefe;\n  border: 1px solid #e8ecef;\n  border-radius: 12px;\n}\n\n.newchatlist-content h4 {\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  text-align: left;\n  width: fit-content;\n  letter-spacing: -0.5px;\n}\n\n.newchatlist-content .form-group {\n  margin-bottom: 0px;\n}\n\n.newchatlist-content .form-group label {\n  color: #141718;\n  margin-bottom: 10px;\n}\n\n.newchatlist-container {\n  flex-direction: row;\n  width: 600px;\n}\n\n.newchatlist-column {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n\n  small {\n    margin-top: 20px;\n    color: #B6B8B9;\n  }\n}\n\n.newchatlist-column h5 {\n  margin-bottom: 10px;\n  margin-top: 20px;\n  font-weight: 600;\n  letter-spacing: -0.5px;\n  font-size: 15px;\n}\n\n.newchatlist-row {\n  display: flex;\n  flex: 1;\n  align-items: center;\n}\n\n.newchatlist-select-color {\n  margin-left: 20px;\n  width: 265px;\n}\n\n.newchatlist-name {\n  width: 265px;\n}\n\n.newchatlist-name-input {\n  height: 48px;\n  border-radius: 12px;\n  border-color: #E7ECEE;\n}\n\n.input-container {\n  display: flex;\n  align-items: center;\n  border: 1px solid #E7ECEE;\n  border-radius: 12px;\n  padding: 4px 6px 4px 16px;\n}\n\n.icon-container {\n  display: flex;\n  align-items: center;\n  padding: 4px;\n}\n\n.search-icon {\n  color: #B6B8B9;\n}\n\n.input-field {\n  flex: 1;\n  border: none;\n  padding: 8px;\n  font-size: 14px;\n}\n\n.select-container-mail {\n  width: 330px;\n  border: \"none\"; // Remove a borda\n  box-shadow: \"none\"; // Remove a sombra\n}\n\n.newcharlist-select-color-container {\n  border: 1px solid #E7ECEE;\n}\n\n.newcharlist-select-color {\n  box-shadow: none;\n  width: 265px;\n}\n\n.newcharlist-panel {\n  border: 1px solid #E7ECEE;\n  border-radius: 12px;\n  padding: 16px;\n  background-color: #fff;\n\n}\n\n.newchatlist-card {\n  margin-left: 30px;\n  justify-content: space-between;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
